import { SwapVert as SwapVertIcon } from "@mui/icons-material";
import ButtonOrMenuItem from "atoms/ButtonOrMenuItem";
import { httpClient } from "misc/dataProvider";
import { apiEndpoint } from "misc/settings";
import { useState } from "react";
import { useNotify } from "react-admin";

type SendInvoicesToAccountingButtonOrMenuItemPropsType = {
  invoiceIds: number[];
  disabled?: boolean;
};

export default function SendInvoicesToAccountingButtonOrMenuItem(
  props: SendInvoicesToAccountingButtonOrMenuItemPropsType,
) {
  const { invoiceIds, disabled = false } = props;
  const [sentOnce, setSentOnce] = useState(false);
  const notify = useNotify();

  const sendInvoicesToAccounting = () => {
    const url = `${apiEndpoint}/accounting/sync_invoices/`;

    httpClient(url, { method: "PUT", body: JSON.stringify({ ids: invoiceIds }) });
    setSentOnce(true);
    notify("resources.invoices.hints.accounting_transfer_started", { type: "info" });
  };

  return (
    <ButtonOrMenuItem
      label="invoice.send_to_accounting"
      onClick={sendInvoicesToAccounting}
      data-testid="send-invoices-to-accounting-button"
      disabled={invoiceIds.length === 0 || sentOnce || disabled}
    >
      <SwapVertIcon />
    </ButtonOrMenuItem>
  );
}
